<template>
  <div class="container-fluid">
    <div class="page-title"><h3>Tarifa de envío</h3></div>
    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4"><label class="form-label">Tarifa base</label><input v-model.number="form.baseFare" type="number" class="form-control" /></div>
          <div class="col-md-4"><label class="form-label">Factor distancia (por km)</label><input v-model.number="form.perKm" type="number" class="form-control" /></div>
          <div class="col-md-4"><label class="form-label">Factor peso (por kg)</label><input v-model.number="form.perKg" type="number" class="form-control" /></div>
          <div class="col-md-6"><label class="form-label">Factor volumen</label><input v-model.number="form.perVolumeFactor" type="number" class="form-control" /></div>
          <div class="col-md-6"><label class="form-label">Cargo urgencia</label><input v-model.number="form.urgencySurcharge" type="number" class="form-control" /></div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary" @click="save">Guardar tarifas</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shippingRatesApi } from '@/api/shipping-rates';

export default {
  name: 'TarifaEnvio',
  data() {
    return {
      form: {
        baseFare: 40,
        perKm: 2.5,
        perKg: 8,
        perVolumeFactor: 0.0005,
        urgencySurcharge: 25,
      },
    };
  },
  mounted() {
    this.fetchRate();
  },
  methods: {
    async fetchRate() {
      const { data } = await shippingRatesApi.getActive();
      if (data) this.form = { ...this.form, ...data };
    },
    async save() {
      await shippingRatesApi.updateActive(this.form);
    },
  },
};
</script>

